import { render, staticRenderFns } from "./RewardPage.vue?vue&type=template&id=787ae34f"
import script from "./RewardPage.vue?vue&type=script&lang=js"
export * from "./RewardPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports